import { ERROR_TYPE } from '~/constants/error';

export default class NetworkError extends Error {
  name = ERROR_TYPE.NETWORK_ERROR;
  message = 'Network Error';
}
